/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { PatchConsigneeSelfServiceCheckinFinishRequest } from '../../models/patch-consignee-self-service-checkin-finish-request';

export interface PatchConsigneeSelfServiceCheckinFinish$Params {
  organizationSiteKey: KeyType;
  checkinKey: KeyType;
      body: PatchConsigneeSelfServiceCheckinFinishRequest
}

export function patchConsigneeSelfServiceCheckinFinish(http: HttpClient, rootUrl: string, params: PatchConsigneeSelfServiceCheckinFinish$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patchConsigneeSelfServiceCheckinFinish.PATH, 'patch');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('checkinKey', params.checkinKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

patchConsigneeSelfServiceCheckinFinish.PATH = '/organization-sites/{organizationSiteKey}/self-checkin/checkins/{checkinKey}';
